import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import Link from 'components/Link'
import config from '../../../../../../config'

const getBannerTheme = props => props.theme.ringierBanner
const getMargin = props => getBannerTheme(props).margin || '0 0 0 40px'
const getLandscapeMargin = props => getBannerTheme(props).landscape.margin || '0 0 0 100px'
const getLandscapeBannerLeftMargin = props => getBannerTheme(props).landscape.bannerLeftMargin || '100px'
const getPadding = props => getBannerTheme(props).padding || '40px'
const getLandscapePadding = props => getBannerTheme(props).landscape.padding || '40px'
const getFontSize = props => getBannerTheme(props).fontSize
const getLandscapeFontSize = props => getBannerTheme(props).landscape.fontSize
const getLineHeight = props => getBannerTheme(props).lineHeight
const getTitleFontWeight = props => getBannerTheme(props).titleFontWeight
const getTitleFontFamily = props => getBannerTheme(props).titleFontFamily
const getLandscapeTitleFontSize = props => getBannerTheme(props).landscape.titleFontSize
const getBackgroundColor = props => getBannerTheme(props).backgroundColor
const getBorderRadius = props => getBannerTheme(props).borderRadius || '0'

const RingierBannerView = styled.div`
  box-sizing: border-box;
  padding: ${getPadding};
  margin: ${getMargin};
  font-size: ${getFontSize};
  line-height: ${getLineHeight};
  background-color: ${getBackgroundColor};

  ${breakpoint('landscape')`
    font-size: ${getLandscapeFontSize};
    border-radius: ${getBorderRadius}
    line-height: 24px;
    margin: ${getLandscapeMargin};
    padding: ${getLandscapePadding};
  `};
`

const RingierBannerTitle = styled.div`
  font-weight: ${getTitleFontWeight};
  font-family: ${getTitleFontFamily};
  font-size: ${getLandscapeTitleFontSize};
  margin-bottom: 20px;
`

const RingierBannerSpacing = styled.div`
  height: 60px;
  width: 100%;
`

const RingierBannerBenefit = styled.div`
  display: flex;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 40px;
  }
`

const getIcon = props => getBannerTheme(props).benefitsIcon
const getIconWidth = props => getBannerTheme(props).iconWidth
const getIconHeight = props => getBannerTheme(props).iconHeight
const getMessageColor = props => getBannerTheme(props).benefitMessageColor
const getLinkColor = props => getBannerTheme(props).linkColor
const getLinkHoverColor = props => getBannerTheme(props).linkHoverColor
const getLinkFontSize = props => getBannerTheme(props).linkFontSize
const getBenefitFontFamily = props => getBannerTheme(props).benefitFontFamily

const RingierBannerBenefitIcon = styled.img.attrs(props => ({
  src: getIcon(props),
}))`
  width: ${getIconWidth};
  height: ${getIconHeight};
  padding-right: 10px;
  flex-shrink: 0;
`

const RingierBannerBenefitMessage = styled.div`
  color: ${getMessageColor};
  font-family: ${getBenefitFontFamily};
`

const RingierBannerLink = styled(Link)`
  color: ${getLinkColor};
  font-size: ${getLinkFontSize};

  &:hover {
    color: ${getLinkHoverColor};
  }
`

const RingierBannerGameImage = styled.img`
  display: none;
  ${breakpoint('portrait')`
    display: block;
    margin-left: 40px;
    margin-bottom: 20px;
    width: calc(100% - 40px);
  `};

  ${breakpoint('landscape')`
    margin-left: ${getLandscapeBannerLeftMargin};
    width: calc(100% - ${getLandscapeBannerLeftMargin});
  `};
`
const getOnelogSection = props => getBannerTheme(props).onelogSection || {}
const getOnelogSectionPadding = props => getOnelogSection(props).padding || '0'
const getOnelogSectionBorderTop = props => getOnelogSection(props).borderTop || 'none'

const RingierBannerBrandsContainer = styled.div`
  padding: ${getOnelogSectionPadding};
  border-top: ${getOnelogSectionBorderTop};
  display: flex;
  flex-direction: column;
  align-items: center;
`

const getOnelogLogo = props => getBannerTheme(props).onelogLogo || {}
const getOnelogLogoSrc = props => getOnelogLogo(props).src || `${config.url}/assets/logo-onelog-black.svg`
const getOnelogLogoHeight = props => getOnelogLogo(props).height || '28px'
const getOnelogLogoWidth = props => getOnelogLogo(props).width || '132px'
const getOnelogLogoMargin = props => getOnelogLogo(props).margin || '0 0 8px 0'

const RingierBannerOnelogLogo = styled.img.attrs(props => ({
  src: getOnelogLogoSrc(props),
}))`
  height: ${getOnelogLogoHeight};
  width: ${getOnelogLogoWidth};
  margin: ${getOnelogLogoMargin};
`

const getOnelogTitle = props => getBannerTheme(props).onelogTitle || {}
const getOnelogTitleFontFamily = props => getOnelogTitle(props).fontFamily
const getOnelogTitleFontWeight = props => getOnelogTitle(props).fontWeight
const getOnelogTitleFontSize = props => getOnelogTitle(props).fontSize
const getOnelogTitleLineHeight = props => getOnelogTitle(props).lineHeight
const getOnelogTitleColor = props => getOnelogTitle(props).color
const getOnelogTitleMargin = props => getOnelogTitle(props).margin

const RingierBannerOnelogTitle = styled.p`
  font-family: ${getOnelogTitleFontFamily};
  font-weight: ${getOnelogTitleFontWeight};
  font-size: ${getOnelogTitleFontSize};
  line-height: ${getOnelogTitleLineHeight};
  color: ${getOnelogTitleColor};
  margin: ${getOnelogTitleMargin};
`

export {
  RingierBannerView,
  RingierBannerTitle,
  RingierBannerBenefit,
  RingierBannerBenefitIcon,
  RingierBannerBenefitMessage,
  RingierBannerLink,
  RingierBannerGameImage,
  RingierBannerSpacing,
  RingierBannerBrandsContainer,
  RingierBannerOnelogLogo,
  RingierBannerOnelogTitle,
}
